import {Component, forwardRef} from '@angular/core';
import {DictionariesService} from "../../service";
import {QrefDokt4936Model} from "../../models";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {ViewDictionaryBase} from "./view-dictionary-base";

@Component({
  selector: 'app-dict-qref-qrefDokt4936',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => QrefDokt4936ViewComponent),
    multi: true
  }],
  template: `
    <div class="mb-3">
      <label class="form-label">{{title}}
        <app-rq *ngIf="isFieldReq(formControl)" [isReadOnly]="isDisabled"></app-rq>
      </label>
      <app-custom-select *ngIf="dictionary | async as dict; else loading"
                         [items]="dict"
                         [returnOnlyId]="true"
                         [formControl]="formControl"
                         [fieldsFromSearch]="'name'"
                         [isInvalid]="submitted && formControl.errors">
        <ng-template let-item #labelTemplate>
          <b>{{ item.code }}</b>
          {{ item.name }}
        </ng-template>
        <ng-template let-item let-search="search" #optionTemplate>
          <div style="white-space: normal">
            <b>{{ item.code }}</b>
            {{ item.name }}
          </div>
        </ng-template>
      </app-custom-select>
      <ng-template #loading>
        ...загрузка
      </ng-template>
      <app-valid [logic]="formControl" [submitted]="submitted"></app-valid>
    </div>
  `
})
export class QrefDokt4936ViewComponent extends ViewDictionaryBase<QrefDokt4936Model> {
  getDictionary = this.dictSrv.getQrefDokt4936List();
  constructor(private dictSrv: DictionariesService) {
    super();
  }
}
